import { ModalCenter } from "@/components/atoms/ModalCenter";
import { LoadingSpinner } from "@/components/molecules/LoadingSpinner";
import { Scanner } from "@/components/scanner/Scanner";
import { ScannerForm } from "@/components/scanner/ScannerForm";
import { useScannerGetAll, useScannerUpdate } from "@/lib/api/scanner";
import { ScannerSchema, Scanner as ScannerType } from "@/lib/types/scanner.ts";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { useState } from "react";

export const ScannersOverview = () => {
  const [openedForm, { open: openForm, close: closeForm }] = useDisclosure()

  const [selected, setSelected] = useState<ScannerType | undefined>()

  const scannerUpdate = useScannerUpdate()

  const { data: scanners, isLoading } = useScannerGetAll();

  if (isLoading) return <LoadingSpinner />;

  const handleEdit = (scanner: ScannerType) => {
    setSelected(scanner)
    openForm()
  }

  const handleSubmit = (scanner: ScannerSchema) => {
    scannerUpdate.mutate(scanner, {
      onSuccess: () => notifications.show({ variant: "success", message: "Updated scanner" }),
      onSettled: () => {
        closeForm()
        setSelected(undefined)
      }
    });
  }

  return (
    <>
      <div className="grid 2xl:grid-cols-2 gap-8">
        {scanners?.map(s => (
          <Scanner key={s.id} scanner={s} onEdit={handleEdit} />
        ))}
      </div>
      <ModalCenter
        opened={openedForm}
        onClose={closeForm}
        title="Edit scanner"
      >
        <ScannerForm scanner={selected} close={closeForm} onSubmit={handleSubmit} />
      </ModalCenter>
    </>
  );
};
